// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IModuleI18n } from '@platform/core/types/modularity/IModuleI18n';
import type { IModuleManifest } from '@platform/core/types/modularity/IModuleManifest';

/** Пакет модуля «Аудити» (Audits, ключ `audit`, група `oversight`). */
export const auditsManifest: IModuleManifest = {
  key: 'audit',
  group: 'oversight',
  slug: 'audits',
  prefix: 'AUD',
  name: { en: 'Audits', uk: 'Аудити' },
  entities: [
    { key: 'audit', slug: 'audit', name: { en: 'Audits', uk: 'Аудити' }, main: true },
    { key: 'audit_finding', slug: 'audit-finding', name: { en: 'Audit Findings', uk: 'Висновки' }, main: false },
    { key: 'audit_recommendation', slug: 'audit-recommendation', name: { en: 'Audit Recommendations', uk: 'Рекомендації' }, main: false },
    { key: 'audit_team_member', slug: 'audit-team-member', name: { en: 'Audit Team Members', uk: 'Члени команди аудиту' }, main: false },
    { key: 'audit_document', slug: 'audit-document', name: { en: 'Audit Documents', uk: 'Документи' }, main: false },
    { key: 'audit_status', slug: 'audit-status', name: { en: 'Audit Statuses', uk: 'Статуси' }, main: false },
  ],
  loadState: () => import('./state/auditsSlice').then((m) => m.auditsSlice),
  loadI18n: (lng) => (lng === 'uk' ? import('./i18n/uk.json') : import('./i18n/en.json')).then((m) => m.default as IModuleI18n),
  loadDefinition: () => import('./definition').then((m) => m.definition),
};
